import type { LeadRecord, LeadStatus, PepLeadSettings } from "@itaas/pep-contracts";

import { PEP_API_BASE } from "../config";



const ADMIN_KEY_STORAGE = "pep-admin-key";

const IAM_TOKEN_STORAGE = "pep-iam-token";



export function getAdminKey(): string | null {

  return sessionStorage.getItem(ADMIN_KEY_STORAGE);

}



export function setAdminKey(key: string) {

  sessionStorage.setItem(ADMIN_KEY_STORAGE, key);

  sessionStorage.removeItem(IAM_TOKEN_STORAGE);

}



export function getIamToken(): string | null {

  return sessionStorage.getItem(IAM_TOKEN_STORAGE);

}



export function setIamToken(token: string) {

  sessionStorage.setItem(IAM_TOKEN_STORAGE, token);

  sessionStorage.removeItem(ADMIN_KEY_STORAGE);

}



export function clearAdminKey() {

  sessionStorage.removeItem(ADMIN_KEY_STORAGE);

  sessionStorage.removeItem(IAM_TOKEN_STORAGE);

}



export function isAdminAuthenticated(): boolean {

  return Boolean(getAdminKey() || getIamToken());

}



export async function adminFetch<T>(path: string, init?: RequestInit): Promise<T> {

  const iamToken = getIamToken();

  const key = getAdminKey();

  if (!iamToken && !key) throw new Error("NOT_AUTHENTICATED");



  const headers: Record<string, string> = {

    "Content-Type": "application/json",

    ...(init?.headers as Record<string, string> | undefined),

  };



  if (iamToken) {

    headers.Authorization = `Bearer ${iamToken}`;

  } else if (key) {

    headers["x-pep-admin-key"] = key;

  }



  const res = await fetch(`${PEP_API_BASE}${path}`, {

    ...init,

    headers,

  });



  if (res.status === 401) {

    clearAdminKey();

    throw new Error("NOT_AUTHENTICATED");

  }

  if (!res.ok) throw new Error(`API ${path}: ${res.status}`);

  return res.json() as Promise<T>;

}



export function fetchLeads(type?: string, affiliateCode?: string) {
  const params = new URLSearchParams();
  if (type) params.set("type", type);
  if (affiliateCode) params.set("affiliateCode", affiliateCode);
  const q = params.toString();
  return adminFetch<LeadRecord[]>(`/leads${q ? `?${q}` : ""}`);
}



export function updateLeadStatus(id: string, status: LeadStatus) {

  return adminFetch<LeadRecord>(`/leads/${id}/status`, {

    method: "PATCH",

    body: JSON.stringify({ status }),

  });

}



export function fetchPepSettings() {

  return adminFetch<PepLeadSettings>("/admin/settings");

}



export function savePepSettings(patch: Partial<PepLeadSettings>) {

  return adminFetch<PepLeadSettings>("/admin/settings", {

    method: "PATCH",

    body: JSON.stringify(patch),

  });

}

export function recordAffiliateConversion(leadId: string) {
  return adminFetch<LeadRecord>(`/leads/${leadId}/record-affiliate-conversion`, {
    method: "POST",
  });
}

export function sendTestEmail() {
  return adminFetch<{ sent: boolean; mode: "smtp" | "log_only"; recipients: string[] }>(
    "/admin/settings/test-email",
    { method: "POST" },
  );
}

